/* assets/register-pending-modal.js
   全站偵測：若在非 /account/register 且有 ny_reg_pending 才顯示彈窗
*/
(function () {
  var ON_REGISTER = /\/account\/register(\?|$|\/)/i.test(location.pathname);
  if (ON_REGISTER) return; // 只在離開註冊頁後才可能彈窗（成功情境）

  var COOKIE = 'ny_reg_pending';
  function getCookie(name) {
    var m = document.cookie.split(';').map(function (s) { return s.trim(); })
      .find(function (s) { return s.indexOf(name + '=') === 0; });
    return m ? decodeURIComponent(m.split('=').slice(1).join('=')) : '';
  }
  function delCookie(name) {
    document.cookie = name + '=; path=/; SameSite=Lax; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  var flag = getCookie(COOKIE);
  if (!flag) return;
  delCookie(COOKIE); // 讀到一次就清除

  var LOGIN_URL = '/account/login';

  // 樣式
  var css = document.createElement('style');
  css.textContent = `
    .ny-modal-mask{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.45);z-index:9999}
    .ny-modal{background:#fff;max-width:560px;width:min(92vw,560px);border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.2)}
    .ny-modal header{padding:18px 20px;border-bottom:1px solid #eee;font-weight:700;font-size:18px}
    .ny-modal .ny-body{padding:18px 20px;line-height:1.6;font-size:16px}
    .ny-modal .ny-actions{display:flex;gap:12px;justify-content:flex-end;padding:16px 20px;border-top:1px solid #eee}
    .ny-btn{appearance:none;border:1px solid #1f2937;background:#1f2937;color:#fff;border-radius:8px;padding:10px 14px;font-size:15px;cursor:pointer}
    .ny-btn:focus{outline:2px solid #111827;outline-offset:2px}
    .ny-sub{color:#6b7280;margin-top:8px}
  `;
  document.head.appendChild(css);

  // 結構
  var wrap = document.createElement('div');
  wrap.className = 'ny-modal-mask';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.innerHTML =
    '<div class="ny-modal">' +
      '<header>Account Created</header>' +
      '<div class="ny-body">' +
        '<div><strong>Account has been created and is pending approval.</strong></div>' +
        '<div>Please try logging in later. Thank you!</div>' +
        '<div class="ny-sub">This window will close and return to the login page in ' +
          '<span id="nyCountdown">10</span> seconds.</div>' +
      '</div>' +
      '<div class="ny-actions">' +
        '<button id="nyBackNow" class="ny-btn" type="button">Back to login page</button>' +
      '</div>' +
    '</div>';

  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(wrap);

    var sec = 10, timer = null;
    function goLogin(){ location.href = LOGIN_URL; }
    function tick() {
      var cd = document.getElementById('nyCountdown');
      if (cd) cd.textContent = String(sec);
      if (sec-- <= 0) { clearInterval(timer); goLogin(); }
    }
    timer = setInterval(tick, 1000); tick();
    document.getElementById('nyBackNow').addEventListener('click', function(){
      try { clearInterval(timer); } catch(e){}
      goLogin();
    });
  });
})();
